import React, { useEffect, useRef, useState, useMemo } from 'react';
import Wrapper from "../components/Wrapper.js";
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import Api from '../Api.js';
import EventModal from '../components/EventModal.js';
import { useSelector } from "react-redux";
import MyButton from '../components/Button/Button.js'
import qs from "query-string";
import { useLocation, useNavigate } from "react-router-dom"
import Select from "react-select";
import ClearIcon from '@mui/icons-material/Clear';
import { IconButton, Tooltip } from '@mui/material';
const customStyles = {
    menu: (base) => ({
        ...base,
        zIndex: 99999999999999, // Set a high z-index to avoid being hidden
    }),
    menuPortal: (base) => ({
        ...base,
        zIndex: 99999999999, // very high to sit above modals
    }),

};
function Calendar(props) {
    const [events, setEvents] = useState([]);
    const [users, setUsers] = useState([]);
    const [data, setData] = useState(null)
    const [type, setType] = useState(0)
    const [selectedTitle, setSelectedTitle] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedDate, setSelectedDate] = useState('');
    const calendarRef = useRef()
    const navigate = useNavigate()
    const location = useLocation()
    const query = qs.parse(location.search, { arrayFormat: 'comma' });
    const selectedUserIds = useMemo(() => {
        const ids = query.user_ids;
        return ids ? (Array.isArray(ids) ? ids : ids.split(',').map(Number)) : [];
    }, [query]);

    const selectedOptions = useMemo(() => {
        return users.map(u => ({
            label: `${u.user.first_name}`, value: u.user_id
        })).filter(option => selectedUserIds.includes(option.value.toString()));
    }, [users, selectedUserIds]);

    const login = useSelector((state) => state.manager.employee);

    const account = useSelector((state) => state.task.accountant);
    const managers = useSelector((state) => state.task.managers);
    useEffect(() => {
        if (calendarRef.current) {
            calendarRef.current.getApi().updateSize();
        }
    }, []);
    useEffect(() => {
        setUsers([...account, ...managers]);

    }, [account, managers]);
    useEffect(() => {
        Api.getEvents(query.type, query.user_ids)
            .then(res => setEvents(res.data))
            .catch(err => console.error('Error fetching events:', err));
    }, [location.search]);
    useEffect(() => {
        if (!query.type) {
            query.type = 0
            navigate(`?${qs.stringify(query, {
                arrayFormat: 'comma',
                skipEmptyString: true,
            })}`);
        }
    }, []);
    const handleChange = selected => {
        const ids = selected.map(u => u.value);
        const newQuery = {
            ...query,
            user_ids: ids.length > 0 ? ids.join(',') : undefined
        };

        navigate({
            pathname: location.pathname,
            search: qs.stringify(newQuery, { skipNull: true }),
        });
    };

    const handleDateClick = (arg) => {

        if (selectedTitle) return;
        setData(null);
        setSelectedDate(arg.dateStr);
        setModalOpen(true);
    };
    const handleButtonClick = (ind) => {
        setType(ind)
        query.type = ind
        navigate(`?${qs.stringify(query, {
            arrayFormat: 'comma',
            skipEmptyString: true,
        })}`);
    };

    const handleDeleteEvent = async (eventId) => {
        try {

            await Api.deleteEvent(eventId._def.publicId);
            setEvents(prev => {
                console.log(prev);
                return prev.filter(e => +e.id !== +eventId._def.publicId)

            });
        } catch (err) {
            console.error('Error deleting event:', err);
        }
    };
    const handleSaveEvent = async (eventData) => {
        try {
            if(eventData.dayoff){
                Api.getEvents(query.type, query.user_ids)
                .then(res => setEvents(res.data))
                .catch(err => console.error('Error fetching events:', err));
            }else{
                const response = await Api.createEvent({ ...eventData, type });
                setEvents(prev => [...prev, response.data]);
            }
            
        } catch (err) {
            console.error('Error saving event:', err);
        }
    };
    const handleSaveEditEvent = async (eventData, id) => {
        try {
            const response = await Api.editEvent(eventData, id);
            setEvents(prev => [...prev, response.data]);
            if (eventData.dayoff) {
                const formData = new FormData()
                formData.append('approved', eventData.status === "approved" ? 1 : eventData.status === "pending" ? 0 : 2)
                await Api.statusDayOff(eventData.dayoff, formData)
            }

        } catch (err) {
            console.error('Error saving event:', err);
        }
    };

    // const handleEventDrop = async (info) => {
    //     const originalEvent = info.event;
    //     const start = info.event.start;
    //     const newStartDate = info.event.start;  // This contains the correct dragged date with correct time
    //     const originalStart = originalEvent.start;  // This contains the original time you want to preserve

    //     const originalHour = new Date(originalStart).getHours();
    //     const originalMinute = new Date(originalStart).getMinutes();

    //     newStartDate.setHours(originalHour);
    //     newStartDate.setMinutes(originalMinute);

    //     const newEndDate = info.event.end;
    //     if (newEndDate && originalEvent.end) {
    //         const originalEnd = new Date(originalEvent.end);
    //         newEndDate.setHours(originalEnd.getHours());
    //         newEndDate.setMinutes(originalEnd.getMinutes());
    //     }

    //     const copiedEvent = {
    //         title: originalEvent.title,
    //         start: newStartDate.toISOString(),  
    //         end: newEndDate ? newEndDate.toISOString() : null,
    //         description: originalEvent.extendedProps.description,
    //         status: originalEvent.extendedProps.status,
    //         created_by: originalEvent.extendedProps.created_by,
    //         dayoff: originalEvent.extendedProps.dayoff,
    //     };
    //     const response = await Api.editEvent(copiedEvent, info.event._def.publicId);
    //     setEvents(prev => [...prev, response.data]);
    // };

    const handleEventDrop = async (info) => {
        const originalEvent = info.event;
        const originalStart = originalEvent._instance.range.start; 
        const originalHour = originalStart.getHours();
        const originalMinute = originalStart.getMinutes();
        const droppedStartDate = new Date(info.event.start);
        droppedStartDate.setHours(originalHour, originalMinute, 0, 0);
    
        let droppedEndDate = null;
        if (info.event.end && originalEvent.end) {
            const originalEnd = originalEvent._instance.range.end;
            droppedEndDate = new Date(info.event.end);
            droppedEndDate.setHours(originalEnd.getHours(), originalEnd.getMinutes(), 0, 0);
        }
    
        const copiedEvent = {
            title: originalEvent.title,
            start: droppedStartDate.toISOString(),
            end: droppedEndDate ? droppedEndDate.toISOString() : null,
            description: originalEvent.extendedProps.description,
            status: originalEvent.extendedProps.status,
            created_by: originalEvent.extendedProps.created_by,
            dayoff: originalEvent.extendedProps.dayoff,
        };
    
        const response = await Api.editEvent(copiedEvent, info.event._def.publicId);
    
        setEvents(prev =>
            prev.map(ev => ev.id === response.data.id ? response.data : ev)
        );
    };
    
    return (
        <Wrapper>
            <div className='w-100' style={{ margin: '20px 0 100px' }}>
                <div className='tasks-buttons' style={{ margin: '20px 0' }}>
                    {login.is_lecturer ? ["Սովորական", "Ակադեմիայի"].map((item, index) => {
                        return (
                            <MyButton
                                key={index}
                                buttonStyle={index === type ?
                                    "middle-button task-button task-button-active" : "middle-button task-button"}
                                title={item}
                                onChangeValue={() => handleButtonClick(index)}
                            />
                        );
                    }) : null}

                </div>
                <div style={{ margin: "30px 0" }}>
                    <Select
                        isMulti
                        options={users.map(u => ({
                            label: `${u.user.first_name} ${u.user.last_name}`, value: u.user_id
                        }))}
                        value={selectedOptions}
                        onChange={handleChange}
                        placeholder="Ֆիլտրել ըստ աշխատակցի..."
                        isSearchable
                        styles={customStyles}
                    />
                </div>
                {selectedTitle && (
                    <div style={{
                        position: 'fixed',
                        bottom: 24,
                        right: 24,
                        zIndex: 1000, // make sure it's above other elements
                    }}>
                        <Tooltip title="Ավարտել">
                            <IconButton
                                onClick={() => setSelectedTitle(null)}
                                color="error"
                                sx={{ bgcolor: 'blue', color:"white", '&:hover': { bgcolor: '#fdd' } }}
                            >
                                <ClearIcon />
                            </IconButton>
                        </Tooltip>
                    </div>
                )}
                <FullCalendar
                    ref={calendarRef}
                    plugins={[dayGridPlugin, interactionPlugin]}
                    initialView="dayGridMonth"
                    events={events}
                    dateClick={handleDateClick}
                    selectable={true}
                    select={async (info) => {
                        if (selectedTitle) {
                            let startDate = selectedTitle._instance.range.start.toISOString().split('T')[1].replace(".000Z", "")
                            let entDate = selectedTitle._instance.range.end.toISOString().split('T')[1].replace(".000Z", "")

                            const newEvent = {
                                title: selectedTitle.title,
                                start: info.startStr + "T" + startDate,
                                end: info.startStr + "T" + entDate,
                                created_by: selectedTitle._def.extendedProps.created_by,
                                description: selectedTitle._def.extendedProps.description,
                                user: selectedTitle._def.extendedProps.user,
                            };

                            await handleSaveEvent(newEvent)


                        }
                    }}
                    eventClassNames={(arg) => {
                        const status = arg.event.extendedProps.status;
                        return [
                            status === 'approved' ? 'event-approved' : '',
                            status === 'rejected' ? 'event-rejected' : '',
                            status === 'pending' ? 'event-pending' : ''
                        ];
                    }}
                    eventContent={(arg) => {
                        const title = arg.event.title;
                        let us = users.find(l => l.user_id === arg.event.extendedProps.created_by)?.user
                        const createdBy = us ? `${us.first_name} ${us.last_name}` : 'Unknown';
                        const start = arg.event.start;
                        const end = arg.event.end;

                        const formatTime = (date) => {
                            const hours = date?.getHours().toString().padStart(2, '0');
                            const minutes = date?.getMinutes().toString().padStart(2, '0');
                            return `${hours}:${minutes}`;
                        };

                        return (
                            <div style={{ padding: 5, maxWidth: '100%', width: "100%", boxSizing: 'border-box' }}>
                                <div className='d-flex justify-content-end'>
                                    <i
                                        style={{ color: "#4f4f4f" }}
                                        className="fas fa-copy" onClick={(e) => {
                                            e.stopPropagation(); // prevent calendar click interference
                                            setSelectedTitle(arg.event);
                                        }} />
                                    <i
                                        style={{ marginLeft: 10, color: "#4f4f4f" }}
                                        className="fas fa-trash" onClick={(e) => { e.stopPropagation(); handleDeleteEvent(arg.event) }} />
                                </div>
                                <Tooltip title={title} arrow />
                                <div

                                    title={title}
                                    style={{
                                        color: "#07608d",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        fontWeight: "bold",
                                        maxWidth: '100%',
                                        display: 'block',
                                    }}
                                >
                                    {title}
                                </div>
                                <div style={{ fontSize: '0.8em', color: "#07608d" }}>
                                    {formatTime(start)} - {formatTime(end)}
                                </div>
                                <div style={{ fontSize: '0.75em', color: '#555' }}>By: {createdBy}</div>
                            </div>
                        );
                    }}
                    eventClick={(info) => {
                        if (selectedTitle) return;
                        const eventStart = info.event.start; // This is a JS Date object
                        const dateStr = eventStart.toISOString().split('T')[0]; // Extract "YYYY-MM-DD"

                        setSelectedDate(dateStr)
                        setData(info.event);
                        setModalOpen(true);
                    }}
                    editable={true}
                    eventDrop={handleEventDrop}

                />
            </div>
            {modalOpen && !selectedTitle ? <EventModal
                data={data}
                setData={setData}
                open={modalOpen && !selectedTitle}
                handleClose={() => setModalOpen(false)}
                handleSave={handleSaveEvent}
                handleEditSave={handleSaveEditEvent}
                date={selectedDate}
            /> : null}

        </Wrapper>
    );

}

export default Calendar;